class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      document.querySelector('body').classList.remove('open-filter','open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500);
      this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
      const applyfilter = this.querySelector('.apply-filter');
      const filterbtn = this.querySelector('.filter-button');
      const sortbtn = this.querySelector('.sort-button');
      if (filterbtn) filterbtn.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-filter');
      document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search');
    });    
      if (sortbtn) sortbtn.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-sort');
      document.querySelector('body').classList.remove('open-filter','open-drawer','open-menu','open-search');
    });
    //   if(document.querySelector('.sort-box')){
    //   this.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    // }
    }
  static setListeners() {
      const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }
  
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  
  static renderSectionFromFetch(url, event) {
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      // mobile filter js starts from hree
      // filteActiveFun()

      let filter_count = document.querySelectorAll('.filter-box input:not([type="radio"]):checked').length;
      var sortingButton = document.querySelector('.sorting-button-fordesktop');
      var sortingButtonMobile = document.querySelector('.sorting-button-formobile');
      if(filter_count > 0){
        sortingButton.classList.add('active')
        sortingButtonMobile.classList.add('active')
      }else{
        sortingButton.classList.remove('active')
        sortingButtonMobile.classList.remove('active')
      }
      
    });
    }
      static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
   
        // filteActiveFun()
    }
      static renderProductGridContainer(html) {
      document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
      let count = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').getAttribute('data-count');
      document.querySelector('.pro-count').textContent = count;
      document.querySelector('.count-item').textContent = count;
      if(count > 1){
          document.querySelector('.items').textContent = "items";
      }
      else{
          document.querySelector('.items').textContent = "item";
      }
    }
      static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const facetDetailsElements =
        parsedHTML.querySelectorAll('.filter-index');

      const active_filter_div =  parsedHTML.querySelector('.active_filter_div').innerHTML;
        document.querySelector('.active_filter_div').innerHTML = active_filter_div;
     
      const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
      
          const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.clickEvents();
  }

  static clickEvents(){
    var collsort = document.querySelectorAll(".collection_sorting");
    collsort.forEach(function (e) {
      e.addEventListener("click",function(e){
        e.preventDefault(), e.stopImmediatePropagation();
        console.log('d');        
        this.parentElement.parentElement.classList.toggle("active");
      });
    });
    document.querySelectorAll(".facet-list").forEach(function(event){
      if(event.querySelectorAll("input[type=checkbox]:checked").length > 0){
        event.querySelector("h4").classList.add("active");
      }else{
        event.querySelector("h4").classList.remove("active");
      }
    })
    document.querySelectorAll(".filterwrap input[type=checkbox]:checked").forEach((evt) => {
      evt.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector("h4").classList.add("active")
    })
        

    document.querySelectorAll(".facet-list h4").forEach(function(e){
      e.addEventListener("click",function(event){
        event.preventDefault(), event.stopImmediatePropagation();
        console.log("parent")
        this.parentElement.classList.toggle("active");
      });
    });
    var Back_filter_btn = document.querySelectorAll(".back-filter-icon");
    Back_filter_btn.forEach(function(e){
      e.addEventListener("click",function(event){
        event.preventDefault(), event.stopImmediatePropagation();
        this.parentElement.parentElement.parentElement.classList.remove("active")
      })    
    });
        // sorting js start sfrom here
    if(document.querySelector(".filter-sort")){
    var ONloadVlau = document.querySelector(".filter-sort ul li.active").querySelector("label .label_span_val").innerHTML;
    document.querySelector(".sorting_value").innerHTML = ONloadVlau;
    document.querySelectorAll("input[name='sort_by']+label").forEach(function(e){
      e.addEventListener("click",function(event){
        // event.preventDefault(), event.stopImmediatePropagation();
        document.querySelector(".filter-sort ul li.active").classList.remove("active");
          var Value = e.querySelector(".label_span_val").innerHTML;
          document.querySelector(".sorting_value").innerHTML = Value;
          this.parentElement.classList.add("active");
          if(window.innerWidth < 768){
          console.log()
            document.querySelectorAll(".facet-list.active .filter-inner-all-filters ul li label").forEach(function(evtt){
              evtt.addEventListener("change",function(){
                this.classList.add("activated")
              })
            })
          }
      })
    });
    }

    const show_filter = () => {
      // document.getElementById('dialog').classList.add('show')
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
      const body = document.body;
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
    };
    const close_filter = () => {
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
      // document.getElementById('dialog').classList.remove('show');
    }
  window.addEventListener('scroll', () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}`);
  });
    
  document.querySelectorAll(".filter-button-close").forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      
      // if (element.classList.contains("collection-filter-button")) {
      // } else if (element.classList.contains("collection-filter-close-icon")) {
      // }

      const parent = this.closest('.collection_filters_main');
      if (parent) {
        parent.classList.remove('active');
      }

      document.querySelector('body').classList.remove('open-filter-popup');
      close_filter();
    });
  });
  

    if(document.querySelectorAll(".more-filter-shows .facet-list").length > 0){
      console.log("more fikter",1)
      document.querySelector(".show_more_filtre_btn").style.display = "block";
      if(window.innerWidth > 600){
        window.scrollTo(0, 0)
        }
    }else{
      console.log("more fikter",0)
        document.querySelector(".Price_ranger_index").classList.add("no_more_filter");
      document.querySelector(".show_more_filtre_btn").style.display = "none";
        if(window.innerWidth > 600){
        window.scrollTo(0, 0)
        }
    }
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
onSubmitHandler(event) {    
  event.preventDefault();
  const formData = new FormData(event.target.closest('form'));
  const searchParams = new URLSearchParams(formData);

  if (searchParams.get('filter.v.option.size')) {
    searchParams.set('filter.v.availability', '1');
  }

  FacetFiltersForm.renderPage(searchParams.toString(), event);
}

onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
  
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.clickEvents();
function filterprice(){
  var inputLeft = document.querySelector(".price-left");
  var inputRight = document.querySelector(".price-right");
  var amountLeft = document.querySelector(".amount-left .amount-percentage");
  var amountRight = document.querySelector(".amount-right .amount-percentage");
  var thumbLeft = document.querySelector(".price-slider > .thumb.left");
  var thumbRight = document.querySelector(".price-slider > .thumb.right");
  var range = document.querySelector(".price-slider > .range");
  function setLeftValue() {
    var _this = inputLeft,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbLeft.style.left = percent + "%";
    amountLeft.innerHTML = _this.value;
    range.style.left = percent + "%";
  }
  setLeftValue();
  function setRightValue() {
    var _this = inputRight,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbRight.style.right = (100 - percent) + "%";
    amountRight.innerHTML = _this.value;
    range.style.right = (100 - percent) + "%";
    _this.style.zIndex  = 3;    
  }
  setRightValue();
  inputLeft.addEventListener("input", setLeftValue);
  inputRight.addEventListener("input", setRightValue);
}
if(document.querySelector('.range-wrap') != null){
    filterprice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect()



function filteActiveFun(){
  document.querySelectorAll(".facet-list h4").forEach(function(e){
    e.addEventListener("click",function(event){
      event.preventDefault(), event.stopImmediatePropagation();
      console.log("parent")
    this.parentElement.classList.toggle("active");
  });
})
// back button js start from here
var Back_filter_btn = document.querySelectorAll(".back-filter-icon");
Back_filter_btn.forEach(function(e){
  e.addEventListener("click",function(event){
    event.preventDefault(), event.stopImmediatePropagation();
      this.parentElement.parentElement.parentElement.classList.remove("active")
  })    
})

// brand search js starts from here
document.querySelector(".brand_filter_search .filter-search-input").addEventListener("keypress",function(e){
  setTimeout(function(){
  var NextInput = e.target.parentElement.parentElement.nextElementSibling.querySelectorAll("li");
  console.log(NextInput)
  var SearchValue = e.target.value.toLowerCase();
  var key = e.which || e.keyCode || e.charCode;
  console.log(SearchValue,key)
      NextInput.forEach(function(event){
      var FilterValue = event.querySelector("input").dataset.filtervalue;
          if (FilterValue.indexOf(SearchValue) > -1) {
          event.style.display = "block";
          } else {
          event.style.display = "none";
          }
      })
  }, 0);
});

document.querySelector(".brand_filter_search .filter-search-input").addEventListener("keydown",function(e){
  var key = event.keyCode || event.charCode;
  var NextLi = e.target.parentElement.parentElement.nextElementSibling.querySelectorAll("li");
  console.log(NextLi)
  setTimeout(function(){
      if( key == 8 || key == 46 ){
          if(e.target.value == ""){
              NextLi.forEach(function(event){
                  event.style.display="block"
              })
              console.log("backspace",e.target.value)
          }
      }
    }, 0);
});

// sorting toggle class js starts from here
// document.querySelector(".collection_sorting").parentElement.parentElement.classList.remove("active");
  // document.querySelectorAll(".collection_sorting").forEach(function(e){
  /*document.querySelector(".collection_sorting").addEventListener("click",function(e){
    console.log("click occur")
    if(this.parentElement.parentElement.classList.contains("active")){
        this.parentElement.parentElement.classList.remove("active");
    }else{
      this.parentElement.parentElement.classList.add("active");
    }
      
    });*/
  // })
  document.querySelector(".collection_sorting").addEventListener("click",function(e){
    this.parentElement.parentElement.classList.toggle("active");
  });
  // sorting js start sfrom here
  var ONloadVlau = document.querySelector(".filter-sort ul li.active").querySelector("label .label_span_val").innerHTML;
  document.querySelector(".sorting_value").innerHTML = ONloadVlau;
  document.querySelectorAll("input[name='sort_by']+label").forEach(function(e){
    e.addEventListener("click",function(event){
      // event.preventDefault(), event.stopImmediatePropagation();
        var Value = e.querySelector(".label_span_val").innerHTML;
        document.querySelector(".sorting_value").innerHTML = Value;
    })
  })
}


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function updateFilter(){
  // document.querySelector(".collection_sorting").addEventListener("click",function(e){
  //   console.log('test',this.nextElementSibling);
  //   this.nextElementSibling.classList.toggle('sortToggle');
  // });
  /*document.querySelectorAll(".facet-list h4").forEach(function(e){
      e.addEventListener("click",function(e){
        console.log("parent")
       // this.parentElement.classList.toggle("active");
      });
  })*/
}
//updateFilter();

document.addEventListener('DOMContentLoaded', function() {
  var sortingButton = document.querySelector('.sorting-button-fordesktop');
  var collectionItemsFlex = document.querySelector('.collection_items_flex');

  sortingButton.addEventListener('click', function() {
    collectionItemsFlex.classList.toggle('show-filter');
  });
});

let filter_count = document.querySelectorAll('.filter-box input:not([type="radio"]):checked').length;
var sortingButton = document.querySelector('.sorting-button-fordesktop');
var sortingButtonMobile = document.querySelector('.sorting-button-formobile');
if(filter_count > 0){
  sortingButton.classList.add('active')
  sortingButtonMobile.classList.add('active')
}else{
  sortingButton.classList.remove('active')
  sortingButtonMobile.classList.remove('active')
}
